import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";

/**
 * Handle plant effects
 */
@Injectable()
export class BuildingEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _store = inject(Store);
}
